import { queryKeys } from '../keys'
import { DEFAULT_RETRY_MUTATION } from '../config'
import type { QueryClient } from '@tanstack/react-query'
import type { GetUserProfileResponse } from '@/types/user'
import { authService } from '@/services'

const mutateLogin = (queryClient: QueryClient) => {
  return queryClient.setMutationDefaults(queryKeys.auth.login(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: (payload: Parameters<typeof authService.login>[0]) =>
      authService.login(payload),
  })
}

const mutateLogout = (queryClient: QueryClient) => {
  return queryClient.setMutationDefaults(queryKeys.auth.logout(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: () => authService.logout(),
  })
}

const mutateRegister = (queryClient: QueryClient) => {
  return queryClient.setMutationDefaults(queryKeys.auth.register(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: (payload: Parameters<typeof authService.register>[0]) =>
      authService.register(payload),
    onSuccess: (res) => {
      queryClient.setQueryData<GetUserProfileResponse>(
        queryKeys.user.profile(),
        res,
      )
    },
  })
}

const mutateResetPassword = (queryClient: QueryClient) => {
  return queryClient.setMutationDefaults(queryKeys.auth.resetPassword(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: (payload: Parameters<typeof authService.resetPassword>[0]) =>
      authService.resetPassword(payload),
  })
}

const mutateVerifyResetPassword = (queryClient: QueryClient) => {
  return queryClient.setMutationDefaults(queryKeys.auth.verifyResetPassword(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: (
      payload: Parameters<typeof authService.verifyResetPassword>[0],
    ) => authService.verifyResetPassword(payload),
  })
}

const mutateDoResetPassword = (queryClient: QueryClient) => {
  return queryClient.setMutationDefaults(queryKeys.auth.doResetPassword(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: (payload: Parameters<typeof authService.doResetPassword>[0]) =>
      authService.doResetPassword(payload),
  })
}

export function registerAuthMutations(queryClient: QueryClient) {
  mutateLogin(queryClient)
  mutateLogout(queryClient)
  mutateRegister(queryClient)
  mutateResetPassword(queryClient)
  mutateVerifyResetPassword(queryClient)
  mutateDoResetPassword(queryClient)
}
